'use client'

import classNames from 'classnames'
import Link from 'next/link'

import { Button } from '@/packages/news-ui/basic/button'
import errorImage from '@/shared/assets/error.png'
import { useI18n } from '@/shared/providers'

import styles from './view.module.css'

type ErrorProps = {
    statusCode: number
    title: string
    message?: string
    digest?: string
}

export function ErrorWidget(props: ErrorProps) {
    const { statusCode, title, message, digest } = props
    const { i18n } = useI18n()

    return (
        <div className={styles.errorPageMainContent}>
            <div className={styles.customErrorPage}>
                <div className={styles.customErrorPageDiv}>
                    <h1 className={classNames(styles.errorHero, 'text-muted')}>{statusCode}</h1>
                    <h2 className={classNames(styles.errorSubtitle, 'text-muted')}>{title.toUpperCase()}</h2>
                    {message && <p className="text-muted">Message: {message}</p>}
                    {digest && <p className="text-muted">Digest: {digest}</p>}
                    <img
                        src={errorImage.src}
                        width={508}
                        height={400}
                        alt="under_construction"
                        className={styles.star}
                        draggable="false"
                    />
                    <Link href="/" style={{ textDecoration: 'none' }}>
                        <Button size="lg" className="w-100">
                            {i18n.BUTTON_RETURN_HOME}
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    )
}
